import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import api from '../../../config/axios';
import Swal from 'sweetalert2';

import { FaPlus, FaEdit, FaFilter, FaEye, FaPrint, FaFileAlt, FaFileCode } from 'react-icons/fa';
import Paginacao from '../../../components/utils/paginacao';
import DatePicker from '../../../components/utils/datepicker';
import { autoCompleteFornecedores } from '../../../components/utils/autocompletes';
import NovoPedidoCompra from './modals/NovoPedidoCompra';

const PedidosCompra = () => {
  const [error, setError] = useState(null);
  const [pedidos, setPedidos] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [usuarioLogado, setUsuarioLogado] = useState(null);

  const [filtroDataDe, setFiltroDataDe] = useState(null);
  const [filtroDataAte, setFiltroDataAte] = useState(null);
  const [filtroUnidade, setFiltroUnidade] = useState('');
  const [selectedFornecedor, setSelectedFornecedor] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPedido, setSelectedPedido] = useState(null);
  const [tipoNovoPedido, setTipoNovoPedido] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const limit = 10;

  const { fornecedoresOptions, handleAutoCompleteFornecedores, handleFocusFornecedores } = autoCompleteFornecedores();

  const pedidosMock = [
    {
      id: 1,
      numero: 'PC-001',
      fornecedor: { nome: 'DISTRIBUIDORA BELEZA TOTAL LTDA' },
      data_pedido: '2025-01-03',
      data_entrega: '2025-01-10'
    },
    {
      id: 2,
      numero: 'PC-002',
      fornecedor: { nome: 'COSMÉTICOS PREMIUM S.A.' },
      data_pedido: '2025-01-02',
      data_entrega: '2025-01-08'
    },
    {
      id: 3,
      numero: 'PC-003',
      fornecedor: { nome: 'PRODUTOS CAPILARES BRASIL' },
      data_pedido: '2024-12-28',
      data_entrega: '2025-01-05'
    },
    {
      id: 4,
      numero: 'PC-004',
      fornecedor: { nome: 'BARBERSHOP SUPPLIES LTDA' },
      data_pedido: '2024-12-20',
      data_entrega: '2024-12-27'
    },
    {
      id: 5,
      numero: 'PC-005',
      fornecedor: { nome: 'DISTRIBUIDORA BELEZA TOTAL LTDA' },
      data_pedido: '2025-01-05',
      data_entrega: '2025-01-15'
    }
  ];

  const fetchUsuarioLogado = async () => {
    try {
      const response = await api.get('/pessoas/me');
      setUsuarioLogado(response.data);
    } catch (error) {
      const userDataArmazenado = localStorage.getItem('userData');
      if (userDataArmazenado) {
        setUsuarioLogado(JSON.parse(userDataArmazenado));
      }
    }
  };

  const fetchUnidades = async () => {
    try {
      const response = await api.get('/unidades?limit=1000');
      setUnidades(response.data.unidades || []);
    } catch (error) {
      setUnidades([
        { id: 1, nome: 'Unidade Centro' },
        { id: 2, nome: 'Unidade Shopping' },
        { id: 3, nome: 'Unidade Zona Sul' }
      ]);
    }
  };

  const fetchPedidos = async (page) => {
    try {
      Swal.fire({
        title: "Carregando...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      await new Promise(resolve => setTimeout(resolve, 500));

      Swal.close();
      setPedidos(pedidosMock);
      setTotalPages(1);
      setTotalRegistros(pedidosMock.length);
      setError(null);
    } catch (err) {
      Swal.close();
      setError('Erro ao carregar a lista de pedidos de compra.');
    }
  };

  useEffect(() => {
    fetchUsuarioLogado();
    fetchUnidades();
  }, []);

  useEffect(() => {
    if (usuarioLogado && unidades.length > 0) {
      const unidadeUsuario = usuarioLogado.dadosColaborador?.unidade_designacao_id ||
                            usuarioLogado.unidade_designacao_id;
      if (unidadeUsuario) {
        setFiltroUnidade(unidadeUsuario.toString());
      }
    }
  }, [usuarioLogado, unidades]);

  useEffect(() => {
    fetchPedidos(currentPage);
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleNovoPedidoManual = () => {
    setSelectedPedido(null);
    setTipoNovoPedido('manual');
    setIsModalOpen(true);
  };

  const handleNovoPedidoXML = () => {
    setSelectedPedido(null);
    setTipoNovoPedido('xml');
    Swal.fire({
      title: 'Em desenvolvimento',
      text: 'A importação via XML será implementada em breve.',
      icon: 'info',
      confirmButtonColor: '#0d6efd'
    });
  };

  const handleEditPedido = (pedido) => {
    setSelectedPedido(pedido);
    setTipoNovoPedido('manual');
    setIsModalOpen(true);
  };

  const handleViewPedido = (pedido) => {
    Swal.fire({
      title: 'Em desenvolvimento',
      text: 'A visualização do pedido será implementada em breve.',
      icon: 'info',
      confirmButtonColor: '#0d6efd'
    });
  };

  const handlePrintPedido = (pedido) => {
    Swal.fire({
      title: 'Em desenvolvimento',
      text: 'A impressão do pedido será implementada em breve.',
      icon: 'info',
      confirmButtonColor: '#0d6efd'
    });
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedPedido(null);
    setTipoNovoPedido(null);
  };

  const handlePedidoSalvo = () => {
    handleCloseModal();
    fetchPedidos(currentPage);
  };

  const handleFornecedorSelect = (selectedOption) => {
    setSelectedFornecedor(selectedOption);
  };

  const handleFiltrar = () => {
    setCurrentPage(1);
    fetchPedidos(1);
  };

  const handleLimparFiltros = () => {
    setFiltroDataDe(null);
    setFiltroDataAte(null);
    setSelectedFornecedor(null);

    const unidadeUsuario = usuarioLogado?.dadosColaborador?.unidade_designacao_id ||
                          usuarioLogado?.unidade_designacao_id;
    if (unidadeUsuario) {
      setFiltroUnidade(unidadeUsuario.toString());
    } else {
      setFiltroUnidade('');
    }
  };

  const formatarData = (dataString) => {
    if (!dataString) return '-';
    const data = new Date(dataString + 'T00:00:00');
    return data.toLocaleDateString('pt-BR');
  };

  const isUnidadeDesabilitada = () => {
    const unidadeUsuario = usuarioLogado?.dadosColaborador?.unidade_designacao_id ||
                          usuarioLogado?.unidade_designacao_id;
    return !!unidadeUsuario;
  };

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-12">
              <h4 className="fw-bold">Pedidos de Compra</h4>
            </div>
          </div>

          <div className="row mt-3 mb-3">
            <div className="col-lg-8 col-md-12 col-12">
              <div className="d-flex flex-column flex-sm-row gap-2">
                <div className="dropdown">
                  <button
                    className="btn btn-outline-primary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <FaPlus className="me-1" />
                    <span className="d-none d-sm-inline">Novo </span>Pedido
                  </button>
                  <ul className="dropdown-menu">
                    <li>
                      <button className="dropdown-item" onClick={handleNovoPedidoManual}>
                        <FaFileAlt className="me-2" />
                        Manual
                      </button>
                    </li>
                    <li>
                      <button className="dropdown-item" onClick={handleNovoPedidoXML}>
                        <FaFileCode className="me-2" />
                        XML
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-4 mb-4">
            <div className="col-lg-3 col-md-6 col-12 mb-3">
              <label className="form-label fw-bold">Período De</label>
              <DatePicker
                selected={filtroDataDe}
                onChange={(date) => setFiltroDataDe(date)}
                placeholderText="dd/mm/aaaa"
              />
            </div>
            <div className="col-lg-3 col-md-6 col-12 mb-3">
              <label className="form-label fw-bold">Período Até</label>
              <DatePicker
                selected={filtroDataAte}
                onChange={(date) => setFiltroDataAte(date)}
                placeholderText="dd/mm/aaaa"
              />
            </div>
            <div className="col-lg-3 col-md-6 col-12 mb-3">
              <label className="form-label fw-bold">Unidade</label>
              <select
                className="form-select"
                value={filtroUnidade}
                onChange={(e) => setFiltroUnidade(e.target.value)}
                disabled={isUnidadeDesabilitada()}
              >
                <option value="">Todas as unidades</option>
                {unidades.map((unidade) => (
                  <option key={unidade.id} value={unidade.id}>
                    {unidade.nome}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-lg-3 col-md-6 col-12 mb-3">
              <label className="form-label fw-bold">Fornecedor</label>
              <Select
                value={selectedFornecedor}
                onChange={handleFornecedorSelect}
                onInputChange={(value) => {
                  handleAutoCompleteFornecedores(value);
                }}
                onFocus={handleFocusFornecedores}
                options={fornecedoresOptions}
                isSearchable
                isClearable
                placeholder="Buscar fornecedor..."
                noOptionsMessage={() => 'Nenhum fornecedor encontrado'}
              />
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-12 d-flex justify-content-end gap-2">
              <button
                className="btn btn-outline-secondary"
                onClick={handleLimparFiltros}
              >
                Limpar
              </button>
              <button
                className="btn btn-custom-primary"
                onClick={handleFiltrar}
              >
                <FaFilter /> Filtrar
              </button>
            </div>
          </div>

          {error ? (
            <p className="error-message">{error}</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped">
                <thead className="table-custom-primary">
                  <tr>
                    <th>Nº</th>
                    <th>Fornecedor</th>
                    <th>Data do Pedido</th>
                    <th>Data da Entrega</th>
                    <th className="text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {pedidos.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center">
                        Nenhum pedido de compra encontrado.
                      </td>
                    </tr>
                  ) : (
                    pedidos.map((pedido) => (
                      <tr key={pedido.id}>
                        <td className="text-nowrap">{pedido.numero}</td>
                        <td className="text-nowrap">{pedido.fornecedor?.nome || '-'}</td>
                        <td className="text-nowrap">{formatarData(pedido.data_pedido)}</td>
                        <td className="text-nowrap">{formatarData(pedido.data_entrega)}</td>
                        <td className="text-center text-nowrap">
                          <button
                            className="btn btn-custom-secondary btn-sm"
                            onClick={() => handleViewPedido(pedido)}
                            title="Visualizar"
                          >
                            <FaEye />
                          </button>
                          <button
                            className="btn btn-custom-secondary btn-sm ms-2"
                            onClick={() => handleEditPedido(pedido)}
                            title="Editar"
                          >
                            <FaEdit />
                          </button>
                          <button
                            className="btn btn-custom-secondary btn-sm ms-2"
                            onClick={() => handlePrintPedido(pedido)}
                            title="Imprimir"
                          >
                            <FaPrint />
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}

          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="mb-3">
              <span>
                Total de registros: <strong>{totalRegistros}</strong>
              </span>
            </div>
            <Paginacao
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>
      <div style={{ height: '50px' }}></div>

      {isModalOpen && tipoNovoPedido === 'manual' && (
        <NovoPedidoCompra
          pedido={selectedPedido}
          onClose={handleCloseModal}
          onSave={handlePedidoSalvo}
        />
      )}
    </div>
  );
};

export default PedidosCompra;
